import { getData } from './getData';

/**
 * @description 32施設の名称taxonomyid返却,per_pageはなんとなく倍.
 * @return {number}
 */

export const getSiteId = () => {
  const pathList = location.pathname.split('/');
  let id: number;
  const getResponse = async () => {
    const url = [`${location.origin}/wp-json/wp/v2/facility_name?per_page=64`];
    return await Promise.all(url.map(getData));
  };

  return getResponse().then((res) => {
    const data = res[0].data;
    for (const d of data) {
      if (pathList[1] == d.slug) id = d.id;
    }
    return id;
  });
};
